import React, { lazy, Suspense, useEffect, useState } from "react";
import { useWatchedStartJobIds } from "./startWatch";

const StartFailureNotifier = lazy(() => import("./StartFailureNotifier"));

/** Always mounted at the app root but loads the notifier (and the Films Ground service it pulls
 *  in) only once a Start has actually been watched; it then stays mounted so any notification
 *  already raised keeps showing. */
const StartFailureHost = () => {
  const watchedIds = useWatchedStartJobIds();
  const [needed, setNeeded] = useState(false);

  useEffect(() => {
    if (watchedIds.length > 0) {
      setNeeded(true);
    }
  }, [watchedIds]);

  return needed ? (
    <Suspense fallback={null}>
      <StartFailureNotifier />
    </Suspense>
  ) : null;
};

export default StartFailureHost;
